import { PayloadAction } from "@reduxjs/toolkit";
import { CategoryDataInterface, CategoryState } from "@/components/CategoryPage/redux/types";

const CategoryReducer = {
  setCategoryData: (state: CategoryState, action: PayloadAction<CategoryDataInterface>) => {
    state.categoryData = action.payload;
  },

  setLoading: (state: CategoryState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },

  setError: (state: CategoryState, action: PayloadAction<any>) => {
    state.error = action.payload;
  },
  setDevice: (state: CategoryState, action: PayloadAction<any>) => {
    state.ua = action.payload;
  },
  setCategorySlug: (state: CategoryState, action: PayloadAction<string>) => {
    state.categorySlug = action?.payload;
  },
};

export default CategoryReducer;
